import { useFreelancerPageContext } from '../../FreelancerPageContext';

export const usePortfolio = () => {
    const { seller, isCurrentUser } = useFreelancerPageContext();
    const hasPortfolio = !!seller?.portfolio?.totalCount && seller?.portfolio?.totalCount > 0;
    const showPortfolio = isCurrentUser ? true : hasPortfolio;
    return {
        hasPortfolio,
        showPortfolio,
        portfolio: seller?.portfolio,
    };
};
